export enum ELoginType {
    LOCAL,
    GOOGLE = 'google',
    NAVER = 'naver',
    KAKAO = 'kakao',
    FACEBOOK = 'facebook',
}